import { render, staticRenderFns } from "./realNameStatus.vue?vue&type=template&id=52293c19&scoped=true"
import script from "./realNameStatus.vue?vue&type=script&lang=js"
export * from "./realNameStatus.vue?vue&type=script&lang=js"
import style0 from "./realNameStatus.vue?vue&type=style&index=0&id=52293c19&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52293c19",
  null
  
)

export default component.exports